import { useContext, useMemo } from 'react';
import { VirtualSlotsPlaceholderContext } from '../slotsPlaceholderContext';
export const useWidgetPlugin = (slotId) => {
    const slots = useContext(VirtualSlotsPlaceholderContext);
    const widgetPlugin = slots?.[slotId] ?? null;
    const PluginComponent = useMemo(() => () => widgetPlugin, [widgetPlugin]);
    return {
        PluginComponent,
        isEmpty: !widgetPlugin,
    };
};
//# sourceMappingURL=useWidgetPlugin.js.map